import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {bindActionCreators} from "redux";
import customerActions from "../../../Actions/customerActions";
import {useDispatch, useSelector} from "react-redux";
import {CustomerConnectionsTable} from "../../CustomerConnections/CustomerConnectionsTable";
import useModal from "../../../Hooks/useModal";
import modals from "../../../Constants/modals";
const CustomerConnections = () => {
    const dispatch = useDispatch();
    const actions = bindActionCreators(customerActions, dispatch);

    const customerConnections = useSelector((state) => state.CustomerReducer.customerConnections);
    const customer = useSelector((state) => state.CustomerReducer.customer);
    const dataLoading = useSelector((state) => state.CommonReducer.dataLoading.customerConnections);
    const {t} = useTranslation();
    const { openModal } = useModal();
    
    useEffect(() => {
        if (!customerConnections && !dataLoading) {
            actions.getCustomerConnections(customer.vbCustomer.customerNumber);
        }
    }, []);

    if (dataLoading) {
        return <div className="spinner spinner-default-green m-auto d-block"/>
    }
    return (
        <div>
            <CustomerConnectionsTable customerConnections={customerConnections} customer={customer?.vbCustomer ?? customer?.vossCustomer}/>
            <button type="button" className="pull-right btn btn-default btn-sm"
                    onClick={() => openModal(modals.EditCustomerConnections)}>{t('common.edit')}</button>
        </div>
    )
}

export default CustomerConnections;